export const NEW = 'Сначала недавно добавленные';
export const OLD = 'Сначала добавленные ранее';
export const SALES = 'Скидки';
export const CHEAP = 'Сначала дешёвые';
export const EXPENSIVE = 'Сначала дорогие';
export const POPULAR = 'Популярные';
